import $ from 'jquery';
import Swiper from 'swiper';
import {Navigation, Controller} from 'swiper/modules';

$('.timeline').each((_, elem) => {
    const mainSlider = elem.querySelector('.timeline__slider');
    const bulletSlider = elem.querySelector('.timeline__bullets');

    const startLast = mainSlider.getAttribute('data-start-last') === '1';
    const lastIndex = parseInt(mainSlider.getAttribute('data-slide-count')) - 1;

    const bullets = new Swiper(bulletSlider, {
        modules: [Controller],
        centeredSlides: true,
        slidesPerView: 'auto',
        spaceBetween: 45,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        initialSlide: startLast ? lastIndex : 0,
    });

    const swiper = new Swiper(mainSlider, {
        modules: [Navigation, Controller],
        slidesPerView: 1,
        spaceBetween: 130,
        centeredSlides: true,
        initialSlide: startLast ? lastIndex : 0,
        navigation: {
            nextEl: elem.querySelector('.swiper-arrow--next'),
            prevEl: elem.querySelector('.swiper-arrow--prev'),
        },
        breakpoints: {
            992: {
                slidesPerView: 3,
                spaceBetween: 130,
                width: 1490,
            },
            1560: {
                slidesPerView: 3,
                spaceBetween: 130
            }
        },
    });

    swiper.controller.control = bullets;
    bullets.controller.control = swiper;

});
